/**
 * donationSubmit — one way in for both donation forms.
 *
 * A signed-in giver records a gift (it stays pending until the payment is
 * confirmed). Everyone else pays through the gateway, and the webhook is what
 * completes the record. There is no path that records money without one of
 * the two.
 */
import { getToken } from './authToken';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function submitDonation({ tenantId, payload }) {
  const token = getToken();

  if (token) {
    const res = await fetch(`${API_URL}/api/donations/public/${tenantId}/donate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.detail || 'Could not record your gift');
    return { mode: 'recorded', ...data };
  }

  const res = await fetch(`${API_URL}/api/stripe/checkout/donation`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      tenant_id: tenantId,
      donor_name: payload.donor_name || '',
      donor_email: payload.donor_email || '',
      donor_phone: payload.donor_phone || null,
      amount: Number(payload.amount),
      message: payload.message || null,
      donor_visibility: payload.donor_visibility || 'anonymous',
      is_anonymous: !!payload.is_anonymous,
      donation_type: payload.donation_type || 'one_time',
      origin_url: window.location.origin,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.url) {
    throw new Error(data.detail
      || 'Card giving is unavailable right now — sign in to record your gift instead');
  }
  window.location.href = data.url;
  return { mode: 'gateway' };
}
